import { useCallback } from 'react';

import { GetStartedInner } from './GetStartedInner';

import type { TOSAComponentInput, TOSALeafNode } from '../../../types';

export function GetStarted({
  formNavigation: { setNext },
  formSteps,
}: TOSAComponentInput<TOSALeafNode>) {
  const handleNavigateNext = useCallback(() => {
    setNext({ formSteps });
  }, [formSteps, setNext]);

  return <GetStartedInner onComplete={handleNavigateNext} />;
}
